<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import cjjzfcsInvoice from "./cjjzfcsInvoice/index.vue";
import {cztdquery,queryNsrinfo,cjjzadd,cjjzquery,cjjzsingleQuery,cjjzclear,cjjzupdate,startTaxGather} from '../../../../../../api/cztds.js'
import config from'../../../../../../../configHttp.js'
import {MainFunction} from '../../../../../../components/util/Function/MainFunction.js'
export default {
  name: "",
  components: {
    cjjzfcsInvoice,
  },
  props:{
	 mxsearch:{
		 type:Object,
		 default:{},
	 },
	 searchdata:{
		 type:Object,
		 default:{},
	 },
	 outlistx:{
		 type:Object,
		 default:{},
	 },
  },
  data: function () {
    return {
			maplist:[
					{
						value:null,
						item:'未采集'
					},
					{
						value:1,
						item:'未采集'
					},
					{
						value:2,
						item:'采集成功'
					},
					{
						value:3,
						item:'采集失败'
					},
					{
						value:4,
						item:'采集中'
					}
				],
		MainFunction:MainFunction,
	  paramsx:{
		  	nsrlx:'',
		  	suoyqNsrsbh:'',
		  	suoyqMc:'',
		  	fangcbh:'',
		  	fangcmc:'',
		  	budcqzh:'',
		  	budcdydm:'',
		  	fangwzldzSheng:'',
		  	fangwzldzShi:'',
		  	fangwzldzXian:'',
		  	fangwzldzXiangz:'',
		  	fangwzldzXx:'',
		  	fangczgsws:'',
		  	fangwsztdbh:'',
		  	fangcyt:'',
			suosqqz:'',
		  	fangcqdsj:this.$getdefultMonth(),
		  	bianglx:'',
		  	biangsj:this.$getdefultMonth(),
		  	jianzmj:'',
		  	chuzfcmj:'',
		  	fangcyz:0,
		  	chuzfcyz:'',
		  	jisbl:'',
		  	jianms:[{
		  		jianmdmhmc:'',
		  		jianmqsyf:this.$getdefultMonth(),
		  		jianmzzyf:this.$getdefultMonth(),
		  		fangcyz:'',
		  		jianmje:'',
		  	},{
		  		jianmdmhmc:'',
		  		jianmqsyf:this.$getdefultMonth(),
		  		jianmzzyf:this.$getdefultMonth(),
		  		fangcyz:'',
		  		jianmje:'',
		  	},{
		  		jianmdmhmc:'',
		  		jianmqsyf:this.$getdefultMonth(),
		  		jianmzzyf:this.$getdefultMonth(),
		  		fangcyz:'',
		  		jianmje:'',
		  	}],
		  	yingnse:0,
		  	liuslfjmse:0,
		  	benqyjse:'0',
		  	benqybtse:0,
	  },
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [{}],
      shaidiag: false,
      invoicediag: false,
      tablekey: 0,
	  shoudata:1,
	  conpid:'',
	  nasrsbhlist:[],
	  tabjson:getdata().tabjson
    };
  },
  mounted() {
		
	  queryNsrinfo().then(res=>{
	  	 if(res.data.code==1){

	  		this.nasrsbhlist = res.data.data
	  	}else{
	  		this.$message.error(res.data.msg)
	  	}
	  })
	  this.change()
  },
  created() {},
  methods: {
		Shui(e){
			this.$showConfirm({
				message: "是否上传税源至税局?",
			}).then((res) => {
				if (res == "confirm") {
				let params = {
					type:'2',
					detailIds:e.id
				}
				startTaxGather(params).then(res=>{
					if(res.data.code == 1 ){
						this.change();
					}else{
						this.$message.error(res.data.msg)
					}
				})
				}
			});
		},
	  updata(){
	  	this.change()
	  	this.$forceUpdate()
	  },
	  getJxzcInfo(){
		  this.change()
	  },
	  dsc(e) {
	  	this.$showConfirm({
	  		message: "确认删除?",
	  	}).then((res) => {
	  		if (res == "confirm") {
	  			let out = [e.id]
	  			this.dreremove(out)
	  		}
	  	});
	  
	  },
	  psc() {
			for(let index = 0 ; index < this.$refs.tablebox.getSelectionval().length ; index++){
				if(this.$refs.tablebox.getSelectionval()[index].caijFlag == '4' ){
					return this.$message.error('不能删除正在采集的数据')
				}
			}
	  	this.$showConfirm({
	  		message: "确认删除?",
	  	}).then((res) => {
	  		if (res == "confirm") {
	  			let out = this.$refs.tablebox.getSelectionval()
	  			let duoxuan = []
	  			if (out.length == 0) {
	  				this.$message.error('请勾选您需要删除的数据')
	  			} else {
	  				out.map(item => {
	  					duoxuan.push(item.id)
	  				})
	  				this.dreremove(duoxuan)
	  			}
	  		}
	  	});
	  },
	  dreremove(e) {
	  	let params = {
	  		id: this.outlistx.id,
	  		suosq: this.outlistx.suosq,
	  		mxIds: e
	  	}
	  	cjjzclear(params).then(res => {
	  		if (res.data.code == 1) {
	  			this.change()
	  		} else {
	  			this.$message.error(res.data.msg)
	  		}
	  	})
	  },
	  dc(){
		  let out =this.$refs.tablebox.getSelectionval()
		  let paramsx=[]
		  out.map(item=>{
			paramsx.push(item.id)
		  })
		 let params = {
				downUrl:config.baseURL+"/land/detail/cjjz/export",
				typeObj:{
					toForm:false,
					fileType:'xlsx',
					fileName:"明细从价计征使用税"+ this.$timestampToStr(new Date(), "yyyyMMdd"),
				},
				params:{
					json:this.tabjson,
					taxDetailCjjzfcsExtendSearchInputDTO:{
						nsrlx:this.searchdata.nsrlx,
						fangcmc:this.searchdata.fangcmc,
						landId:this.outlistx.id
					},
					ids:paramsx
				}
		  }
		  this.$downloadcommon(params)
	  },
	  xzlog(e){
		 Object.keys(this.paramsx).map(key=>{
			 if(key!='jianms'){
				 this.paramsx[key] = ''
			 }else{
				for(let index = this.paramsx.jianms.length ; index < 3 ; index++){
							this.paramsx.jianms.push({
								jianmdmhmc: "",
								jianmqsyf: "",
								jianmzzyf: "",
								fangcyz: "",
								jianmje: ""
							})
						}
				 this.paramsx.jianms.map(item=>{
					 Object.keys(item).map(item1=>{
						 item[item1] = ''
					 })
				 })
			 }
		 })
		 this.invoicediag = true
		 if(this.shoudata<1){
		 	this.shoudata = 1
		 }
		 this.shoudata += 1
	  },
	  bj(e){
		 let params = {
			 id : e.id
		 }
		 cjjzsingleQuery(params).then(res=>{
			 if(res.data.code==1){
				 this.conpid = e.id
				 let leng = res.data.data.jianms.length
				 if(leng<3){
				 	for(let a = 0 ; a < 3 - leng ; a++){
				 		res.data.data.jianms.push({
				 			jianmdmhmc:'',
				 			jianmqsyf:null,
				 			jianmzzyf:null,
				 			fangcyz:'',
				 			jianmje:'',
				 		})
				 	}
				 }
				if(this.shoudata > 1){
					this.shoudata = 1
				}
				this.shoudata = this.shoudata - 1
				if(res.data.data.benqyjse==null){
					res.data.data.benqyjse = ''
				}
				this.paramsx =	res.data.data
				this.invoicediag = true
			}else{
				this.$message.error(res.data.msg)
			}
		 })
	  },
	  nextxz(e){
		  for (let a = 0 ; a < e.jianms.length ; a ++){
		  	if(!e.jianms[a].jianmdmhmc||e.jianms[a].jianmdmhmc==''||!e.jianms[a].fangcyz||e.jianms[a].fangcyz==''||!e.jianms[a].jianmje||e.jianms[a].jianmje==''){
		  		e.jianms.splice(a,1)
				a--
		  	}
		  }
		  if(this.shoudata<1){
			  e.id = this.conpid
			 cjjzupdate(e).then(res=>{
				 if(res.data.code==1){
					 this.change()
					 this.invoicediag = false
				}else{
					this.$message.error(res.data.msg)
				}
			 })
		  }else{
			 e.landId = this.outlistx.id
			 e.nsrsbh = this.outlistx.nsrsbh
			 cjjzadd(e).then(res=>{
				 if(res.data.code==1){
					this.change()
					this.invoicediag = false
				}else{
					this.$message.error(res.data.msg)
				}
			 })
		  }
	  },
	  change(e){
		  	let params = JSON.parse(JSON.stringify(this.searchdata));
		  	params.current = this.pagination.pageNum;
		  	params.size = this.pagination.pageSize;
		  	params.suosq = this.outlistx.suosq
		  	params.landId = this.outlistx.id
		  	params.nsrsbh = this.outlistx.nsrsbh
		  	if(e){
		  		this.pagination.pageNum = 1
		  		this.pagination.paginationkey++
		  	}
		  	cjjzquery(params).then(res=>{
		  		 if(res.data.code==1){
		  			 res.data.data.records.map(item=>{
		  				 if(item.nsrlx){
		  					 this.mxsearch.cjjzNsrxz.map(item1=>{
		  						 if(item.nsrlx==item1.value){
		  							 item.nsrlx = item1.label
		  						 }
		  					 })
		  				 }
		  				  if(item.fangcyt){
		  					 this.mxsearch.cjjzFcyt.map(item1=>{
		  						 if(item.fangcyt==item1.value){
		  							 item.fangcyt = item1.label
		  						 }
		  					 })
		  				 }
		  				 if(item.bianglx){
		  					 this.mxsearch.cjjzTdbglxNsywzz.map(item1=>{
		  						 if(item.bianglx==item1.value){
		  							 item.bianglx = item1.label
		  						 }
		  					 })
							 this.mxsearch.cjjzTdbglxXxxbg.map(item1=>{
									 if(item.bianglx==item1.value){
										 item.bianglx = item1.label
									 }
							 })
		  				 }
		  			 })
					 this.pagination.total = res.data.data.total
		  				this.tableData = res.data.data.records
		  		}else{
		  			this.$message.error(res.data.msg)
		  		}
		  	})
		  
	  },
    closediag() {
      this.invoicediag = false;
    },
	outchange(){},
	suosqchange(){},
    sizechange(e) {
      this.pagination.pageSize = e;
	  this.change('1')
    },
    currentChange(e) {
      this.pagination.pageNum = e;
	  this.change('1')
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
    },

    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
